import request from '@/utils/request'

// 操作员列表
export function admins(params) {
  return request({
    url: '/channel/admins',
    method: 'get',
    params,
  })
}

export function adminsId(params, method, id = '') {
  return request({
    url: `/channel/admins/${id}`,
    method,
    params,
  })
}

export function PAdmins(data) {
  return request({
    url: '/channel/admins',
    method: 'post',
    data,
  })
}

export function handleLog(params) {
  return request({
    url: '/channel/handleLog',
    method: 'get',
    params,
  })
}

//角色列表
export function rolesList(params) {
  return request({
    url: '/api/roles',
    method: 'get',
    params,
  })
}
export function ARolesList(params) {
  return request({
    url: '/channel/roles/list',
    method: 'get',
    params,
  })
}

export function rolesId(data, method, id = '') {
  return request({
    url: `/api/roles/${id}`,
    method,
    data,
  })
}
export function addRole(data) {
  return request({
    url: '/api/roles',
    method: 'post',
    data,
  })
}

// 获取个人信息
export function getProfix(params) {
  return request({
    url: '/api/profix',
    method: 'get',
    params,
  })
}

export function changePassword(data) {
  return request({
    url: '/channel/change_password',
    method: 'post',
    data,
  })
}

export function getConfig(params) {
  return request({
    url: '/api/config',
    method: 'get',
    params,
  })
}

export function postConfig(data) {
  return request({
    url: '/api/config',
    method: 'post',
    data,
  })
}

export function retrieve(data) {
  return request({
    url: '/api/sms/retrieve',
    method: 'post',
    data,
  })
}
export function retrieveLogin(data) {
  return request({
    url: '/api/sms/login',
    method: 'post',
    data,
  })
}
/* export function retrieveLogin(data) {
  return request({
    url: '/api/system/sendSms',
    method: 'post',
    data,
  })
} */

export function checkCode(data) {
  return request({
    url: '/api/checkCode',
    method: 'post',
    data,
  })
}

export function retrievePassword(data) {
  return request({
    url: '/api/retrievePassword',
    method: 'post',
    data,
  })
}

export function wechatLoginState(params) {
  return request({
    url: '/api/login/wechatLoginState',
    method: 'get',
    params,
  })
}

export function wechatBind(data) {
  return request({
    url: '/api/login/wechatBind',
    method: 'post',
    data,
  })
}

export function getOpenWechat(params) {
  return request({
    url: '/api/login/getOpenWechat',
    method: 'get',
    params,
  })
}

export function systemConfig(params) {
  return request({
    url: '/super/config/system',
    method: 'get',
    params,
  })
}

export function adminMenus(params) {
  return request({
    url: '/api/menus',
    method: 'get',
    params,
  })
}
export function menusId(data, method, id = '') {
  return request({
    url: `/api/menus/${id}`,
    method,
    data,
  })
}
export function addMenus(data) {
  return request({
    url: '/api/menus',
    method: 'post',
    data,
  })
}

export function addBatch(data) {
  return request({
    url: '/api/menus/batch',
    method: 'post',
    data,
  })
}
